/**
 * A collection of helper functions to for the main app. Utilizes moment.js and ICS.
 */
 import i18n from '../i18n';
 import moment from 'moment';
 const ics = require('ics');

/**
 * @desc Creates the print view using JSON structure.
 *
 * @param {Array} list - List of dates the child needs to get vaccinated on.
 * @returns json data to use with printJS.
 */
function printJson(list, birthday) {
  var optionsList = dateAfterJune2021(birthday) ? Object.values(i18n.t('Vaccines.OptionsRotavirus')) : Object.values(i18n.t('Vaccines.Options'));
  var jsonData = [];

  for (var i = 0; i < list.length; i++) {
    if (list[i]) {
      var eventDescription = '';
      for (var option in optionsList[i]) {
        eventDescription += "<p>• " + optionsList[i][option].replace('<b>', '').replace('</b>', '') + "</p>";
      }
      jsonData.push({
        date: list[i] + " <p>" + Object.values(i18n.t('Vaccines.Timelines'))[i].displayValue + "</p>",
        vaccine: eventDescription,
        appointment: ""
      })
    }
  }

  jsonData.push({
    date: i18n.t('Sidebar.Header'),
    vaccine: '<p>' + i18n.t('Sidebar.Body1') + '</p>' + '<p>' + i18n.t('Sidebar.Body2') + '</p>' + '<p>' + i18n.t('Sidebar.Body3') + '</p>',
    appointment: i18n.t('Vaccines.Link')
  });

  return jsonData;
}

/**
 * @desc Creates the link to download the ICS calendar.
 *
 * @param {String} icsFile
 */
function downloadIcs(icsFile) {
  var blob = new Blob([icsFile], {
    type: 'text/calendar'
  })

  var blobUrl = URL.createObjectURL(blob);

  var downloadLink = document.getElementById('addScheduleLink');
  downloadLink.href = blobUrl;
  downloadLink.download = i18n.t('Vaccines.GetChild') + ".ics";
}

/**
 * @desc Creates ICS file and google calendar links for vaccines the child will get in the future.
 *
 * @param {*} list - list of vaccines the child has yet to get.
 * @param {*} childName - the childs name.
 * @returns - ICS events list.
 */
function createCalendar(list, childName = null, birthday) {
  var events = [];
  var optionsList = dateAfterJune2021(birthday) ? Object.values(i18n.t('Vaccines.OptionsRotavirus')) : Object.values(i18n.t('Vaccines.Options'));
  var googleElement = document.getElementById('googleCalendarLinks');
  const googleLinks = document.getElementsByClassName("google-links");

  // If the form was reset, we must remove the previous links.
  while(googleLinks.length > 0){
    googleElement.removeChild(googleLinks[0]);
  }

  for (var i = 0; i < list.length; i++) {
    if (list[i]) {
      // If its french, we must reformat it to YYYYMMDD for google and ICS.
      if (i18n.locale == 'fr') {
          list[i] = moment(list[i], "D MMMM, YYYY", 'fr').format("YYYYMMDD", 'en');
      }

      var eventDescription = Object.values(i18n.t('Vaccines.Timelines'))[i].displayValue + ", " + i18n.t('Vaccines.NeedsTo1-3') + " ";
      for (var option in optionsList[i]) {
        eventDescription += "\n" + optionsList[i][option].replace('<b>', '').replace('</b>', '');
      }

      eventDescription += "\n\n" + i18n.t('Vaccines.Link')
      events.push({
        start: moment(list[i]).format("YYYY,MM,DD").split(',').map(item => parseInt(item, 10)),
        title: childName ? i18n.t('Vaccines.GetChild').replace('your child', childName).replace('votre enfant', childName) : i18n.t('Vaccines.GetChild'),
        description: eventDescription
      });

      // Create the link elements for google calender events.
      var element = document.createElement("a");
      element.href = "https://www.google.com/calendar/render?action=TEMPLATE&dates=" +
        moment(list[i]).format("YYYYMMDD") + "/" + moment(list[i]).add(1, 'day').format("YYYYMMDD") +
        "&text=" + (childName ? i18n.t('Vaccines.GetChild').replace('your child', childName).replace('votre enfant', childName) : i18n.t('Vaccines.GetChild')) +
        "&details=" + eventDescription.replaceAll("\n", "%0A");
      element.textContent = (childName ? i18n.t('Vaccines.GetChild').replace('your child', childName).replace('votre enfant', childName) : i18n.t('Vaccines.GetChild')) + ' (' + Object.values(i18n.t('Vaccines.Timelines'))[i].displayValue + ')';
      element.classList.add("google-links");
      element.setAttribute('target', '_blank');
      googleElement.appendChild(element);
    }
  }

  const { value } = ics.createEvents(events);
  return value;
}


/**
 * @desc For rotavirus change, we must check if child is born after June 2021.
 *
 * @param {Moment} date - date given.
 * @returns {Boolean}- if the date is after June 2021.
 */
 function dateAfterJune2021(date) {
  return moment(date, 'x').isAfter('2021-06-01');
}

/**
 * @desc Gets the amount of months between the date given and now.
 *
 * @param {Moment} date - date given.
 * @returns {Number}- How many months between date given and now.
 */
function monthsOld(date) {
  return Math.abs(moment(date, 'x').diff(moment(), 'months', true));
}

/**
 * @desc Adds months to the date specified. Used for accordions to add x months.
 *
 * @param {Moment} date - the date you need to add months to.
 * @param {Number} months - number of months to add.
 * @returns {String} - January 1, 2022 - formatted date + months
 */
function monthsAdd(date, months) {
  if (i18n.locale == 'fr') {
    return moment(date, 'x').add(months, 'months').locale(i18n.locale).format("D MMMM YYYY");
  }
  return moment(date, 'x').add(months, 'months').locale(i18n.locale).format("MMMM D, YYYY");
}

/**
 * @desc Generates two lists using the childs birthday to split the initial list of vaccine timelines.
 *
 * @param {Moment} birthday - moment date object of the childs birthday.
 * @param {*} list - list of vaccine timelines.
 * @returns {Array <Array>} - Array of arrays:
 *    [list of vaccines the child should already have],
 *    [list of vaccines the child needs to get].
 */
function splitVaccinations(birthday, list = []){
  var beforeList = [];
  var afterList = [];
  const ageInMonths = monthsOld(birthday);

  for (var x = 0; x < list.length; x++) {
    if (ageInMonths > list[x].value) {
      beforeList.push(x);
    } else {
      afterList.push(x);
    }
  }
  return [beforeList, afterList];
}

export {
  printJson,
  downloadIcs,
  createCalendar,
  dateAfterJune2021,
  monthsOld,
  monthsAdd,
  splitVaccinations
}
